import axiosInstance from "../../apiAxios/axiosInstance";

export const ModuleList = async(payload) => {
  const response= await axiosInstance.post("/admin/module-list",payload);
   return response.data;
};

export const ActiveModuleList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-module-list",payload);
   return resposne.data
};
export const ActiveModuleBySubscription = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-subscription-module-plan-list",payload);
   return resposne.data
};

export const AddModule = async(payload) => {
const response= await axiosInstance.post("/admin/module-store", payload);
    return response.data;
};

export const ViewModule =async (payload) => {
const response=await  axiosInstance.post("/admin/module-show", payload);
    return response.data;
};

export const UpdateModule = async(payload) => {
  const response= await axiosInstance.post("/admin/module-update", payload);
    return response.data;
};

export const DeleteModule = async(payload) => {
  const response= await axiosInstance.post("/admin/module-delete", payload);
    return response.data;
};

export const ModuleChangeStatus = async(payload) => {
  const response=await axiosInstance.post("/admin/module-status-update", payload);
    return response.data;
};
